<template>
  <main id="main-container">
    <!-- WIDGET CONFIGURATOR -->
    <Hero title="Plantillas" page="Plantillas" />
    <div class="content">
      <Card title="Widgets">
        <div class="row">
          <!-- WIDGET SELECTOR AND FORMS -->
          <div class="col-12 col-md-6">
            <!-- WIDGETS SELECTOR -->
            <label class="form-label">Seleccionar Widget</label>
            <select required class="form-select mt-2" v-model="widgetType">
              <option
                v-for="(row, index) in widgetList"
                v-bind:key="index"
                :value="row.name"
                :label="row.label"
              ></option>
            </select>

            <!-- NumberchartForm-->
            <NumberchartForm
              :widgetConfig="widgetConfig"
              :addNewWidget="addNewWidget"
              :validateCount="validateCount"
              v-if="widgetType == 'numberchart'"
              :widgetType="widgetType"
            >
            </NumberchartForm>

            <!-- FORM SWITCH TYPE -->
            <SwitchForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'switch'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
            ></SwitchForm>

            <!-- Form setValue Indicator -->
            <SetIndicatorForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'setIndicator'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
              :validateCount="validateCount"
            ></SetIndicatorForm>

            <SliderForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'slider'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
              :validateCount="validateCount"
            >
            </SliderForm>

            <FuildLevelIdicatorForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'fluidLevel'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
              :validateCount="validateCount"
            >
            </FuildLevelIdicatorForm>

            <IndicatorForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'indicator'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
            ></IndicatorForm>

            <!-- FORM VALUE INDICATOR TYPE -->

            <IndicatorValueForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'indicatorvalue'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
              :validateCount="validateCount"
            ></IndicatorValueForm>

            <OpenStreetMapsForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'open-streetmaps'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
            ></OpenStreetMapsForm>

            <IotbuttonForm
              :widgetConfig="widgetConfig"
              v-if="widgetType == 'button'"
              :addNewWidget="addNewWidget"
              :widgetType="widgetType"
            ></IotbuttonForm>
          </div>

          <!------ WIDGET PREVIEW --------->
          <div class="col-12 col-md-6">
            <Rtnumberchart
              v-if="widgetType == 'numberchart'"
              :config="widgetConfig"
            ></Rtnumberchart>

            <SetValueIndicator
              v-if="widgetType == 'setIndicator'"
              :config="widgetConfig"
            ></SetValueIndicator>

            <Iotswitch
              v-if="widgetType == 'switch'"
              :config="widgetConfig"
            ></Iotswitch>

            <Iotbutton
              v-if="widgetType == 'button'"
              :config="widgetConfig"
            ></Iotbutton>

            <Iotindicator
              v-if="widgetType == 'indicator'"
              :config="widgetConfig"
            ></Iotindicator>
            <Iotindicatorvalue
              v-if="widgetType == 'indicatorvalue'"
              :config="widgetConfig"
            ></Iotindicatorvalue>

            <OpenStreetMaps
              v-if="widgetType == 'open-streetmaps'"
              :config="widgetConfig"
            >
            </OpenStreetMaps>

            <IotSlider
              v-if="widgetType == 'slider'"
              :config="widgetConfig"
            ></IotSlider>

            <FluidLevelIndicator
              v-if="widgetType == 'fluidLevel'"
              :config="widgetConfig"
            >
            </FluidLevelIndicator>
          </div>
        </div>

        <!-- ADD WIDGET BUTTON -->
        <div class="row pull-right">
          <div class="col-12">
            <button
              class="mb-3 mt-4 btn btn-info"
              @click="submitActiveForm(widgetType)"
            >
              Agregar Widget
            </button>
          </div>
        </div>
      </Card>

      <!-- DASHBOARD PREVIEW -->
      <div class="row">
        <div
          v-for="(widget, index) in widgets"
          :key="index"
          :class="[widget.column]"
        >
          <i
            aria-hidden="true"
            class="fa fa-trash text-danger pull-right mx-2 my-2"
            @click="deleteWidget(index)"
          ></i>

          <SetValueIndicator
            v-if="widget.widget == 'setIndicator'"
            :config="widget"
          ></SetValueIndicator>

          <Rtnumberchart
            v-if="widget.widget == 'numberchart'"
            :config="widget"
          ></Rtnumberchart>

          <Iotswitch
            v-if="widget.widget == 'switch'"
            :config="widget"
          ></Iotswitch>

          <Iotbutton
            v-if="widget.widget == 'button'"
            :config="widget"
          ></Iotbutton>

          <Iotindicator
            v-if="widget.widget == 'indicator'"
            :config="widget"
          ></Iotindicator>

          <Iotindicatorvalue
            v-if="widget.widget == 'indicatorvalue'"
            :config="widget"
          ></Iotindicatorvalue>

          <OpenStreetMaps
            v-if="widget.widget == 'open-streetmaps'"
            :config="widget"
          ></OpenStreetMaps>
          <IotSlider v-if="widget.widget == 'slider'" :config="widget">
          </IotSlider>

          <FluidLevelIndicator
            v-if="widget.widget == 'fluidLevel'"
            :config="widget"
          >
          </FluidLevelIndicator>
        </div>
      </div>

      <!-- SAVE TEMPLATE FORM-->
      <Card title="Guardar plantilla">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <label for="" class="form-label">Nombre de la Plantilla</label>
            <input class="form-control" v-model="templateName" type="text" />
          </div>
          <div class="col-md-5 col-sm-6">
            <label for="" class="form-label">Descripcion</label>
            <input
              class="form-control col-8"
              v-model="templateDescription"
              type="text"
            />
          </div>
          <div v-if="$store.state.auth.userData.role == 'admin' " class="col-md-2 col-sm-3">
          <label class="mb-2">Plantilla Global</label>
            <select v-model="is_global" class="form-select">
              <option selected :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>

        </div>

        <div class="row">
          <div class="col-12 mt-3">
            <button
              class="mb-3 pull-right btn btn-info"
              size="lg"
              @click="saveTemplate()"
              :disabled="widgets.length == 0"
            >
              Guardar Plantilla
            </button>
          </div>
        </div>
      </Card>

      <!-- TEMPLATES TABLE -->

      <Card title="Plantillas">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-vcenter">
            <thead>
              <th>Nombre</th>
              <th>Descripcion</th>
              <th>Cantidad</th>
              <th class="text-center" style="width: 100px">Accion</th>
            </thead>
            <tbody>
              <tr v-for="(row, index) in templates" v-bind:key="index">
                <td>{{ row.name }}</td>
                <td>{{ row.description }}</td>
                <td>{{ row.widgets.length }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-sm btn-alt-danger js-bs-tooltip-enabled"
                    data-bs-toggle="tooltip"
                    title=""
                    data-bs-original-title="Borrar"
                    @click="
                      showAlertConfirm(
                        'Eliminar',
                        '¿Está seguro de Eliminar la Plantilla?',
                        'question',
                        row
                      )
                    "
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  </main>
</template>

<script>
import axios from "@/axios";
import {
  Rtnumberchart,
  Iotindicatorvalue,
  SetValueIndicator,
  Iotswitch,
  Iotindicator,
  OpenStreetMaps,
  Iotbutton,
  IotSlider,
  FluidLevelIndicator,
} from "@/components/Widgets/index";
import {
  SetIndicatorForm,
  NumberchartForm,
  SwitchForm,
  IndicatorForm,
  IndicatorValueForm,
  OpenStreetMapsForm,
  IotbuttonForm,
  SliderForm,
  FuildLevelIdicatorForm,
} from "@/components/Templates/index";

import useApp from "@/composables/useApp";
export default {
  name: "Templates",
  components: {
    Rtnumberchart,
    Iotindicatorvalue,
    Iotbutton,
    SetValueIndicator,
    Iotswitch,
    Iotindicator,
    OpenStreetMaps,
    IotbuttonForm,
    NumberchartForm,
    SwitchForm,
    SetIndicatorForm,
    IndicatorForm,
    IndicatorValueForm,
    OpenStreetMapsForm,
    SliderForm,
    FuildLevelIdicatorForm,
    IotSlider,
    FluidLevelIndicator,
  },
  data() {
    return {
      is_global: false,
      widgets: [],
      templates: [],
      widgetType: "",
      templateName: "",
      templateDescription: "",
      widgetList: [
        { name: "numberchart", label: "Grafico de Numeros Entrada <-" },
        { name: "indicator", label: "Indicador Boleano Entrada <-" },
        { name: "indicatorvalue", label: "Indicador Numerico Entrada <-" },
        { name: "setIndicator", label: "Set Numerico ->IO<-" },
        { name: "switch", label: "Switch ->IO<-" },
        { name: "button", label: "Boton IO ->IO<-" },
        { name: "slider", label: "Slider ->IO<-" },
        { name: "open-streetmaps", label: "Mapas <- OpenStreet" },
        { name: "fluidLevel", label: "Nivel de Fluidos <-" },
      ],

      widgetConfig: {
        userId: "sampleuserid",
        selectedDevice: {
          name: "Home",
          dId: "8888",
        },
        variableFullName: "Variable",
        variable: "",
        variableType: "",
        variableSendFreq: "30",
        unit: "ºC",
        class: "success",
        column: "col-12",
        decimalPlaces: 1,
        minValue: 0,
        maxValue: 100,
        widget: "numberchart",
        icon: "fa-snowflake",
        text: "boton",
        demo: true,
      },
    };
  },

  mounted() {
    const {
      ToastMsgSuccess,
      ToastMsgInfo,
      ToastMsgWarning,
      ToastMsgError,
      ToastMsg,
    } = useApp();
    this.ToastMsgSuccess = ToastMsgSuccess;
    this.ToastMsg = ToastMsg;
    this.ToastMsgInfo = ToastMsgInfo;
    this.ToastMsgError = ToastMsgError;
    this.ToastMsgWarning = ToastMsgWarning;
    this.getTemplates();
    this.showAlertConfirm = (title, text, icon, template) => {
      this.$swal({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteTemplate(template);
        }
      });
    };
  },

  methods: {
    validateCount(obj) {
      if (obj.decimalPlaces > 5) {
        obj.decimalPlaces = 5;
      } else if (obj.decimalPlaces < 1) {
        obj.decimalPlaces = 1;
      }
    },

    //Get Templates
    async getTemplates() {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      try {
        const res = await axios.get("/template", axiosHeaders);

        if (res.data.status == "success") {
          const templates = res.data.data;
          const userId = this.$store.state.auth.userData._id
          this.templates = templates.filter( (obj) => obj.userId == userId )

        }
      } catch (error) {
        this.ToastMsgError("Error Cargando Templates", "server", 5000);
        console.log(error);
        return;
      }
    },

    //Save Template
    async saveTemplate() {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
      };

      this.widgets.forEach((element) => {
        if (element.demo !== undefined) {
          element.demo = false;
        }
      });

      const toSend = {
        template: {
          name: this.templateName,
          is_global : this.is_global,
          description: this.templateDescription,
          widgets: this.widgets,
        },
      };

      try {
        const res = await axios.post("/template", toSend, axiosHeaders);

        if (res.data.status == "success") {
          this.ToastMsgInfo("Plantilla Creada !", "save", 5000);
          this.getTemplates();
          this.widgets = [];
        }
      } catch (error) {
        this.ToastMsgError("Error Creando Plantilla", "server", 5000);
        console.log(error);
        return;
      }
    },

    //Delete Template
    async deleteTemplate(template) {
      const axiosHeaders = {
        headers: {
          token: this.$store.state.auth.token,
        },
        params: {
          templateId: template._id,
        },
      };

      try {
        const res = await axios.delete("/template", axiosHeaders);

        if (res.data.status == "fail" && res.data.error == "template in use") {
          this.ToastMsgWarning(
            "Plantilla en Ocupada ! ",
            "grin-beam-sweat",
            5000
          );

          return;
        }

        if (res.data.status == "success") {
          this.ToastMsgInfo(
            `Plantilla ${template.name} Borrado!`,
            "cloud",
            5000
          );
          this.getTemplates();
        }
      } catch (error) {
        this.ToastMsgWarning("Error Cargando Plantillas !", "cloud", 5000);
        console.log(error);
        return;
      }
    },

    submitActiveForm(widgetType) {
      const activeForm = document.getElementById(widgetType);
      if (activeForm != null) {
        activeForm.requestSubmit();
      }
    },
    //Add Widget
    addNewWidget() {
      this.widgetList.forEach(({ name }) => {
        if (this.widgetType == name) {
          if (this.widgetConfig.variable == ""){
            this.widgetConfig.variable = this.makeid(10);
          }
          this.widgetConfig.widget = name;
          const check_list =  this.widgets.some( obj => obj.variable == this.widgetConfig.variable)

          if (check_list){
            this.ToastMsgError(`Ya existe la ID Variable: ${this.widgetConfig.variable} !`, "cloud", 6000)
            return 
          }else{
            this.widgets.push(JSON.parse(JSON.stringify(this.widgetConfig)));
            this.widgetConfig.variable = ""
          }
        }
      });
    },

    //Delete Widget
    deleteWidget(index) {
      this.widgets.splice(index, 1);
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
  },
};
</script>
